<template>
	<div class="home">
		<Header />
		
		<div class="theme">
			<div class="wrapper">
				<!-- <div class="content-box">
					<h2>Trading for Anyone. Anywhere. Anytime.</h2>
					<p>Trade over 1000 Instruments. Forex, CFDs on Stock Indices, Commodities, Stocks, Metals and Energies.</p>
					<div class="btn-box">
						<a href="#" class="theme-btn btn-one">Create Account</a>
					</div>
				</div> -->

				<van-swipe :autoplay="3000" :duration="300" style="height: 500px;" indicator-color="white" class="banner-box">
					<van-swipe-item  v-for="(item,index) in bannerList" :key="index" >
						<div class="content-box" :style="'background-image: url('+item.img+');'">
							<h2>{{ item.title }}</h2>
							<p>{{ item.subTitle }}</p>
							<div class="btn-box">
								<a href="#" class="theme-btn btn-one">Create Account</a>
							</div>
						</div>
					</van-swipe-item>
				</van-swipe>
			</div>
		</div>
		<div class="marquee wrapper">
			<ul class="stock-list">
				<li class="upper">BTCUSDT 100608.90 <span class="rise">+0.93 <i></i></span></li>
				<li class="lower">USOIL 72.410 <span class="fall">-0.12 <i></i></span></li>
				<li class="lower">XAUUSD 2822.23 <span class="fall">-0.35 <i></i></span></li>
				<li class="upper">UKOIL 75.590 <span class="rise">+0.55 <i></i></span></li>
				<li class="upper">EURUSD 1.03108 <span class="rise">+0.76 <i></i></span></li>
				<li class="lower">USDJPY 155.172 <span class="fall">-0.43 <i></i></span></li>
				<li class="upper">GBPUSD 1.24207 <span class="rise">+0.93 <i></i></span></li>
				<li class="lower">CHINA300 3769.21 <span class="fall">-0.12 <i></i></span></li>
				<li class="lower">TECH100 21464.875 <span class="fall">-0.35 <i></i></span></li>
				<li class="upper">HSBC Holdings 80.32 <span class="rise">+0.55 <i></i></span></li>
				<li class="upper">Goldman Sachs 632.90 <span>+0.76 <i></i></span></li>
				<li class="lower">ETHUSDT 2798.0 <span class="fall">-0.43 <i></i></span></li>
				<li class="upper">BTCUSDT 100608.90 <span class="rise">+0.93 <i></i></span></li>
				<li class="lower">USOIL 72.410 <span class="fall">-0.12 <i></i></span></li>
				<li class="lower">XAUUSD 2822.23 <span class="fall">-0.35 <i></i></span></li>
				<li class="upper">UKOIL 75.590 <span class="rise">+0.55 <i></i></span></li>
				<li class="upper">EURUSD 1.03108 <span class="rise">+0.76 <i></i></span></li>
				<li class="lower">USDJPY 155.172 <span class="fall">-0.43 <i></i></span></li>
				<li class="upper">GBPUSD 1.24207 <span class="rise">+0.93 <i></i></span></li>
				<li class="lower">CHINA300 3769.21 <span class="fall">-0.12 <i></i></span></li>
				<li class="lower">TECH100 21464.875 <span class="fall">-0.35 <i></i></span></li>
				<li class="upper">HSBC Holdings 80.32 <span class="rise">+0.55 <i></i></span></li>
				<li class="upper">Goldman Sachs 632.90 <span class="rise">+0.76 <i></i></span></li>
				<li class="lower">ETHUSDT 2798.0 <span class="fall">-0.43 <i></i></span></li>
			</ul>
		</div>

		<section class="model1">
			<div class="wrapper">
                <div class="sec-title pb_60 centred">
                    <span class="sub-title mb_14">ACCOUNTS</span>
                    <h2>Trading Accounts</h2>
                </div>
                <ul>
                    <li>
                        <div class="account-block-one wow fadeInUp animated animated" data-wow-delay="00ms" data-wow-duration="1500ms" style="visibility: visible; animation-duration: 1500ms; animation-delay: 0ms; animation-name: fadeInUp;">
                            <div class="inner-box">
                                <div class="icon-box"><i class="icon-01"><img src="@/assets/images/account_box.svg" alt=""></i></div>
                                <h3><a href="#">Professional Account</a></h3>
                                <p>Traders with professional accounts gain access to a wide range of benefits, including enhanced trading platforms</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="account-block-one wow fadeInUp animated animated" data-wow-delay="200ms" data-wow-duration="1500ms" style="visibility: visible; animation-duration: 1500ms; animation-delay: 200ms; animation-name: fadeInUp;">
                            <div class="inner-box">
                                <div class="icon-box"><i class="icon-02"><img src="@/assets/images/overview.svg" alt=""></i></div>
                                <h3><a href="#">Overview Account</a></h3>
                                <p>The primary feature of a trading overview account is its ability to aggregate information from multiple accounts.</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="account-block-one wow fadeInUp animated animated" data-wow-delay="400ms" data-wow-duration="1500ms" style="visibility: visible; animation-duration: 1500ms; animation-delay: 400ms; animation-name: fadeInUp;">
                            <div class="inner-box">
                                <div class="icon-box"><i class="icon-03"><img src="@/assets/images/demo.svg" alt=""></i></div>
                                <h3><a href="#">Demo Account</a></h3>
                                <p>Trading demo accounts are particularly valuable for novice traders who are new to the world of investing.</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="account-block-one wow fadeInUp animated animated" data-wow-delay="600ms" data-wow-duration="1500ms" style="visibility: visible; animation-duration: 1500ms; animation-delay: 600ms; animation-name: fadeInUp;">
                            <div class="inner-box">
                                <div class="icon-box"><i class="icon-04"><img src="@/assets/images/vip-fill.svg" alt=""></i></div>
                                <h3><a href="#">Islamic Account</a></h3>
                                <p>Islamic accounts also adhere to ethical guidelines that prohibit trading certain financial instruments deemed</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
			
		</section>
		
		<section class="model3">
			<div class="wrapper">
                <div class="sec-title centred pb_60">
                    <span class="sub-title mb_14">TRADING PLATFORMS</span>
                    <h2>We Offer</h2>
                </div>
                <ul class="inner-container clearfix">
                    <li class="trading-block-one">
                        <div class="inner-box">
                            <figure class="image-box"><img src="@/assets/images/trading-1.png" alt=""></figure>
                            <h3><a href="#">Crypto Trading</a></h3>
                            <p>Trade on price movements with lower commission and tight spreads. Start a smart portfolio with derivatives of BTC, ETH and other altcoins</p>
                            <div class="btn-box"><a href="#" class="theme-btn btn-one">Start Trading Now</a></div>
                        </div>
                    </li>
                    <li class="trading-block-one">
                        <div class="inner-box">
                            <figure class="image-box"><img src="@/assets/images/trading-2.png" alt=""></figure>
                            <h3><a href="#">Shares Trading</a></h3>
                            <p>Trade shares of the most popular stocks from all over the world.</p>
                            <div class="btn-box"><a href="#" class="theme-btn btn-one">Start Trading Now</a></div>
                        </div>
                    </li>
                    <li class="trading-block-one">
                        <div class="inner-box">
                            <figure class="image-box"><img src="@/assets/images/trading-3.png" alt=""></figure>
                            <h3><a href="#">Gold Trading</a></h3>
                            <p>Trade a variety of popular precious metals CFDs with leverage</p>
                            <div class="btn-box"><a href="#" class="theme-btn btn-one">Start Trading Now</a></div>
                        </div>
                    </li>
                    <li class="trading-block-one">
                        <div class="inner-box">
                            <figure class="image-box"><img src="@/assets/images/trading-4.png" alt=""></figure>
                            <h3><a href="#">Currency Trading</a></h3>
                            <p>Trade CFDs on 50+ FX pairs and benefit from razor-thin spreads and lightning execution.</p>
                            <div class="btn-box"><a href="#" class="theme-btn btn-one">Start Trading Now</a></div>
                        </div>
                    </li>
                    <li class="trading-block-one">
                        <div class="inner-box">
                            <figure class="image-box"><img src="@/assets/images/trading-5.png" alt=""></figure>
                            <h3><a href="#">Silver Trading</a></h3>
                            <p>Allows you to trade the most popular precious metals at exceptionally tight pricing.</p>
                            <div class="btn-box"><a href="#" class="theme-btn btn-one">Start Trading Now</a></div>
                        </div>
                    </li>
                </ul>
            </div>
			
		</section>

		<section class="model2">
			<div class="wrapper">
                    <ul>
                        <li class="col-lg-4 col-md-6 col-sm-12 funfact-block">
                            <div class="funfact-block-one">
                                <div class="inner-box">
                                    <div class="til"><span class="odometer odometer-auto-theme" data-count="150">150+</span><span class="text">Countries</span></div>
                                    <p>Trade policies and agreements shape the trading landscape of countries</p>
                                </div>
                            </div>
                        </li>
                        <li class="col-lg-4 col-md-6 col-sm-12 funfact-block">
                            <div class="funfact-block-one">
                                <div class="inner-box">
                                    <div class="til"><span class="odometer odometer-auto-theme" data-count="150">40+</span><span class="text">Million Invest</span></div>
                                    <p>Investing a million dollars in trading represents a significant opportunity and</p>
                                </div>
                            </div>
                        </li>
                        <li class="col-lg-4 col-md-6 col-sm-12 funfact-block">
                            <div class="funfact-block-one">
                                <div class="inner-box">
                                    <div class="til"><span class="odometer odometer-auto-theme" data-count="150">90+</span><span class="text">Awards</span></div>
                                    <p>Trading awards recognize excellence and achievement within the financial</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
			
		</section>
		<!--choose future -->
		<section class="model4">
			<div class="wrapper">
                <div class="sec-title centred light">
                <span class="sub-title">Why F Trade Markets</span>                
				<h2>Reason For <span>Choose F Trade Markets</span></h2>                        
            </div>
            <div class="inner-box">
                <div class="left-column">
                    					                                        <div class="single-item">                                                
						<div class="icon-box">
                            <div class="icon"><img decoding="async" src="@/assets/images/icon-40.png" alt="Awesome Image"></div>
                        </div>
                         
                        <div class="title-text"><h3>High leverage<span>01</span></h3></div>
                        <p>Small amounts of money control large-value assets, magnifying profits (and risks).</p>
                    </div>
                                        					                                        
					<div class="single-item">                      
						<div class="title-text"><h3>Two-way trading<span>02</span></h3></div>
                        <p>Whether the market goes up or down, there are opportunities to make profits.</p>
                                                <div class="icon-box">
                            <div class="icon"><img decoding="async" src="@/assets/images/icon-41.png" alt="Awesome Image"></div>
                        </div>
                                            </div>                    
                                        					                </div>
                <div class="right-column">
                                                            <div class="single-item">                                              
						<div class="icon-box">
                            <div class="icon"><img decoding="async" src="@/assets/images/icon-40.png" alt="Awesome Image"></div>
                        </div>
                         
                        <div class="title-text"><h3>24/7 Support<span>03</span></h3></div>
                        <p>Multiple market access, 24-hour trading, anytime, anywhere.</p>
                    </div>
                                        					                                        <div class="single-item">                    
						<div class="title-text"><h3>Low cost<span>04</span></h3></div>
                        <p>No stamp duty is usually required, and the spread is low, reducing transaction costs.</p>
                                                <div class="icon-box">
                            <div class="icon"><img decoding="async" src="@/assets/images/icon-41.png" alt="Awesome Image"></div>
                        </div>
                                            </div>                    
                                                        </div>
            </div>
        </div>
			
		</section>
		<Footer />
	</div>
</template>

<script>
	import '@/assets/css/base.css';
	import '@/utils/rem.js';
	import { useRoute } from 'vue-router';
	import { defineComponent, reactive, computed, ref, toRefs, onMounted } from "vue";
	import { useStore } from "vuex";
	import config from "@/utils/config";
	import $api from "@/utils/api";
	import Header from "@/components/Header";
	import Footer from "@/components/Footer";
	import { supportedLanguages } from '@/utils/config';
	import {sysPlatform} from "@/utils/util";
	import { useI18n } from 'vue-i18n';
	import {languageInit} from "@/utils/util";
	import i18n from '@/plugins/i18n';
	import { showToast } from "vant";
	import { Swipe, SwipeItem } from 'vant';
	import 'vant/lib/index.css';

	export default {
	name: 'Home',
	components:{
		Header,
		Footer,
		[Swipe.name]: Swipe,
		[SwipeItem.name]: SwipeItem,
	},
	setup(){
		const $i18n = useI18n();
		const {t} = useI18n();
		const $store = useStore();
		const $route = useRoute();
		const state = reactive({
			language:'en_US',
			langObj:{},
			platform:'',
			louis:null,
			versionInfo:{
				ios:"https://apps.apple.com/cn/app/suixinliao/id6468228611",
				android:"",
				googleplay:"https://play.google.com/store/apps/details?id=com.okchat.global"
			},
			bannerList:[
				{
					title:"Trading for Anyone. Anywhere. Anytime.",
					subTitle:"Trade over 1000 Instruments. Forex, CFDs on Stock Indices, Commodities, Stocks, Metals and Energies.",
					img:require('@/assets/images/banner1.jpg')
				},
				{
					title:"Global vision, one touch away",
					subTitle:"From New York to London, from Tokyo to Sydney, the global financial market is at your fingertips. F Trade Markets allows you to transcend geographical restrictions and enjoy the global investment feast.",
					img:require('@/assets/images/banner2.jpg')
				},
				{
					title:"Low cost and high efficiency, smart choice",
					subTitle:"No need to hold physical assets, low threshold to enter the market. Intelligent trading tools help you analyze accurately, making every transaction worthwhile.",
					img:require('@/assets/images/banner3.jpg')
				}
			]
		});

		const download = ref(null);
		const scrollTo = ()=>{
			window.scrollTo({
				// y方向坐标800px（代码中不需要写明单位）
				top: download.value.getBoundingClientRect().top,
				// 滚动方式是平滑滚动 默认是auto 即instant 直接跳到目标位置  不常用
				behavior: "smooth",
			});
		}

		const languageInita = async ()=>{
            /* const sysLanguage = window.navigator.language;
			if($route.query.language!=undefined&&$route.query.language!='') state.language = $route.query.language;
			if(state.language!=undefined){
                const targetLang = supportedLanguages.filter((item)=>item.lang.indexOf(state.language)>-1);

                if(targetLang.length>0){
                    $i18n.locale.value = await languageInit(targetLang[0].lang);
					return;
                }
			} */
			
			/* let lang = ''
			if($route.query.language!=undefined&&$route.query.language!='') state.language = $route.query.language;
			if(state.language){
                const targetLang = supportedLanguages.filter((item)=>item.lang.indexOf(state.language)>-1);
                if(targetLang.length>0){
                    lang = targetLang[0].lang;
                }
			}
            
            $i18n.locale.value = await languageInit(lang);
            state.language = $i18n.locale.value; */
		}
		

		/* const getVersionInfo=()=>{
            $api.getJSON('site.webdown',{lang:state.language}).then((res)=>{
                if(res!=null){
					state.versionInfo.android = "https://file.669669.net/apk/"+res.data;
                }
            });
        }
		getVersionInfo() */

		const appDownload=(platform)=>{
			
			if(platform=='android'){
				window.open(state.versionInfo.android)
			}else if(platform=='googleplay'){
				window.location.href=state.versionInfo.googleplay;
			}else{
				window.location.href=state.versionInfo.ios;
			}

		}
		/* const appDownload=(platform)=>{
			state.louis.install();
		} */

		onMounted(() => {
            window.document.title = t('appName');
			state.platform = sysPlatform();
			//openInstall
			/* const s = document.createElement("script");
			s.type = "text/javascript";
			s.src = "//sdk.mybitdigital.com/web/louis.js"; //在线引用

			//初始化
			s.addEventListener(
			"load",
			() => {
				var data = Louis.parseUrlParams(); //解析获取参数
				new Louis(
				{
					appKey: "av4n3ikb",//根据自己项目配置
					//openinstall初始化完成的回调函数，可选
					onready: function () {
						state.louis = this;
					}
				},
				data
				);
			},
			false
			);
			document.head.appendChild(s); */
        });
	

		languageInita();

		return {
			...toRefs(state),
			download,
			scrollTo,
			appDownload
		}
	}

}
</script>
<style lang="scss">
	@import url('@/assets/css/home.css');
	
</style>